
        import { injectStyle } from '__style_helper__'
        injectStyle("@layer reset{*,*:before,*:after{box-sizing:border-box;min-width:0;font:inherit;outline:0;margin:0;padding:0;list-style:none;position:relative}img,picture,video{shape-margin:.75rem;background-repeat:no-repeat;background-size:cover;max-width:100%;height:auto;font-style:italic;display:block}}")

        export default {}
        